import { HarvestType } from '@/common/constants/harvest.constants';
import { cottonClassificationMap } from '@/features/loads/constants/cotton.standarts';
import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const determineClassByInterval = (
  pollution: number,
  industrialGrade: number,
  harvest_type?: string,
): string | null => {
  if (
    pollution === undefined ||
    pollution === null ||
    pollution < 0 ||
    industrialGrade === undefined ||
    industrialGrade === null
  ) {
    return null;
  }

  const classOrder = ['1', '2', '3'];

  for (const classKey of classOrder) {
    const gradeData = cottonClassificationMap[classKey];
    const gradeRange = gradeData?.[industrialGrade];

    if (!gradeRange) continue;

    const [pollutionMin, pollutionMax] = gradeRange.pollution;

    if (pollution >= pollutionMin && pollution <= pollutionMax) {
      if (
        (harvest_type === HarvestType.COMBINE ||
          harvest_type === HarvestType.GROUND_HARVESTED) &&
        industrialGrade === 1 &&
        classKey === '1'
      ) {
        return '2';
      }

      return classKey;
    }
  }

  return null;
};
